import type * as React from "react";
import { cn } from "../../lib/cn";
import { ActionIconBadge } from "../action-card/ActionIconBadge";
import { ActionStatusBadge } from "../action-card/ActionStatusBadge";
import type { ActionDrawerStatus } from "./types";

export interface ActionDrawerHeaderProps {
  /** Vendor icon (already-rendered React node — caller provides). */
  vendorIcon?: React.ReactNode;
  /** Action label, e.g. "Pianifica invio fattura". */
  title: React.ReactNode;
  /** Subtitle: vendor + entity affected (e.g. "Fatture in Cloud · Cliente Acme S.p.A."). */
  subtitle?: React.ReactNode;
  status: ActionDrawerStatus;
  className?: string;
}

/**
 * Header zone for the inline drawer mode — orange icon badge + title +
 * status pill. Mounts the shared `ActionIconBadge` + `ActionStatusBadge`
 * atoms so the inline surface stays in lock-step with the notification
 * chip + focused view chrome. May 24, 2026 — refactor to single-source
 * the visual identity across every HITL surface.
 */
export const ActionDrawerHeader: React.FC<ActionDrawerHeaderProps> = ({
  vendorIcon,
  title,
  subtitle,
  status,
  className,
}) => (
  <div className={cn("flex items-start gap-3", className)}>
    {vendorIcon ? <ActionIconBadge icon={vendorIcon} size="md" tone="accent" /> : null}
    <div className="min-w-0 flex-1">
      <div className="flex items-center gap-2">
        <h2 className="truncate font-display font-semibold text-base text-ink-1 leading-tight tracking-tight">
          {title}
        </h2>
        <ActionStatusBadge status={status} />
      </div>
      {subtitle ? (
        <p className="mt-0.5 truncate text-ink-2 text-xs">{subtitle}</p>
      ) : null}
    </div>
  </div>
);
ActionDrawerHeader.displayName = "ActionDrawerHeader";
